module.exports = __webpack_public_path__ + "assets/pods_logo_1.c08867d2.png";